import { QueryClientScope } from "../types";
import { getFeatureToggle } from "./getFeatureToggle";
import { FeatureToggleKey, GetFeatureToggleResponse } from "./types";
import { useQuery } from "@tanstack/react-query";

export const useFeatureToggle = (toggleKey: FeatureToggleKey) => {
  return useQuery<GetFeatureToggleResponse | undefined, Error>({
    queryKey: [QueryClientScope.FeatureToggle, toggleKey],
    queryFn: () => getFeatureToggle(toggleKey),
    staleTime: 5 * 60 * 60 * 1000,
  });
};
